import WordPressController from "../controller/WordPressController";
import GlobalWPUser from "./WPUser";


/*
Static Class WPUser (Event calendar WordPress)
*/

class WPCalendarEvent{

    //Token from WPUser
    constructor(){

        this.venues= [];
        this.events = [];
        this.WPCalendarEventController = new WordPressController(); //create WP instance
        this.WPCalendarError = {
            status:null,
            message:null
        }

    }

    /**
     * 
     * GET CALENDAR EVENTS LIST
     */
     async getCalendarEvents(){

        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }
       
        //Retrieve Events
        let response = await this.WPCalendarEventController.WPGetCalendarEvent();
        //console.log(response);
        
        if(response !== undefined && response !== null){
            
            //check status
            if (response.data !==undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
                return await response;
            }else{
                
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
                
                let _ = require('underscore');
                _.each(response.events, function(event){

                    if(event.all_day === false){
                        event.all_day = "Non";
                    }else{
                        event.all_day = "Oui";
                    }
                    if(event.status === "draft"){
                        event.status = "Brouillon";
                    }
                    else if(event.status === "publish"){
                        event.status = "Publié";
                    }
                    else if(event.status === "future"){
                        event.status = "Planifié";
                    }

                    
                });

                this.events = await response.events;
                return await response.events;

            }
            
                                   
            
        }
        else{
            
            
            return await response;
        }

     }

    /**
 * 
 * GET CALENDAR EVENTS LIST
 */
    async getCalendarEventsByID(id){

        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }
        
        //Retrieve Events
        let response = await this.WPCalendarEventController.WPGetCalendarEventByID(id);
        //console.log(response);
        
        if(response !== undefined && response !== null){
            
            //check status
            if (response.data !==undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
                return await response;
            }else{
                
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
                
                if(response.all_day === false){
                    response.all_day = "Non";
                }else{
                    response.all_day = "Oui";
                }
                if(response.status === "draft"){
                    response.status = "Brouillon";
                }
                else if(response.status === "publish"){
                    response.status = "Publié";
                }
                else if(response.status === "future"){
                    response.status = "Planifié";
                }

                    
                this.events = await response;
                return await response;

            }
            
                                    
            
        }
        else{
            
            
            return await response;
        }

    }


    /**
    * 
    * GET CALENDAR VENUES LIST
    */
    async getCalendarVenues(){
        
        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }

        //Retrieve Events
        let response = await this.WPCalendarEventController.WPGetCalendarVenues();
        //console.log(response);
        
        if(response !== undefined && response !== null){
            
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
                
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
                this.venues = await response.venues;
            }
            
            
            return await response.venues;
        }
        else{
            
            return await response;
        }

    }

    /**
    * 
    * GET CALENDAR VENUE BY ID
    */
    getCalendarVenuByID(id){

        let _ = require("underscore");

        let filtered_venue = _.filter(this.venues, function(item){
            return item.id === id;
        });

        if (filtered_venue.length > 0){
            return filtered_venue[0];
        }else{
            return {};
        }

        

    }


    /**
    * 
    * FORCE UPDATE GET CALENDAR VENUE BY ID FROM API
    */
    async getCalendarVenueByIDForce(id){

        //Check Token
        /*let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }*/

        //Get Eventid
        let response = await this.WPCalendarEventController.WPGetCalendarVenueByID(id);
        //console.log(response);
        
        if(response !== undefined && response !== null){
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }                
            return await response;
        }
        else{
            
            
            return await response;
        }

    }

    /**
    * 
    * DELETE CALENDAR EVENT ID
    */
    async deleteCalendarEvent(id){

        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }
        
        //Delete Events
        let response = await this.WPCalendarEventController.WPDeleteCalendarEvent(id);
        //console.log(response);
        
        if(response !== undefined && response !== null){
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }                
            return await response;
        }
        else{
            
            
            return await response;
        }

    }

    /**
    * 
    * ADD CALENDAR EVENT 
    */

    async addCalendarEvent(title, start_date, end_date, publish_date, description, allDay, venueID){

        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }

        //create event
        let response = await this.WPCalendarEventController.WPCalendarEventCreate(title, start_date, end_date, publish_date, description, allDay, venueID);
        
        

        if(response !== undefined && response !== null){
            
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }

            return await response;
        }
        else{
            
            return await response;
        }

    }

    /**
    * 
    * UPDATE CALENDAR EVENT 
    */

     async updateCalendarEvent(id, title, start_date, end_date, publish_date, description, allDay, venueID){

        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }

        //create event
        let response = await this.WPCalendarEventController.WPCalendarEventUpdate(id, title, start_date, end_date, publish_date, description, allDay, venueID);
        
        

        if(response !== undefined && response !== null){
            
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }

            return await response;
        }
        else{
            
            return await response;
        }

    }


    /**
    * 
    * ADD CALENDAR VENUE
    */
    async addCalendarVenue(venue, address, zip, city){

        //create event
        let response = await this.WPCalendarEventController.WPCreateCalendarVenue(venue, address, zip, city);
        
        

        if(response !== undefined && response !== null){
            
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }

            return await response;
        }
        else{
            
            return await response;
        }

    }

    /**
    * 
    * DELETE CALENDAR VENUE ID
    */
     async deleteCalendarVenue(id){

        //Check Token
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }
        
        //Delete Events
        let response = await this.WPCalendarEventController.WPDeleteCalendarVenue(id);
        //console.log(response);
        
        if(response !== undefined && response !== null){
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }                
            return await response;
        }
        else{
            
            
            return await response;
        }

    }


    /**
    * 
    * UPDATE CALENDAR VENUE ID
    */
     async updateCalendarVenue(id,  venue, address, zip, city){

        //Check Token
        //debugger;
        let check_token = await this.WPCalendarEventController.WPIsTokenValid();
        
        if (check_token.data.status !== 200){
            //Authenticate
            await GlobalWPUser.authenticate();
        }
        
        //Update Event Location
        let response = await this.WPCalendarEventController.WPUpdateCalendarVenue(id,venue, address, zip, city);
        //console.log(response);
        
        if(response !== undefined && response !== null){
            //check status
            if (response.data !== undefined && response.data.status !== 200){
                this.WPCalendarError = {
                    status: response.data.status,
                    message: response.message
                }
            }else{
                this.WPCalendarError = {
                    status: null,
                    message: null
                }
            }                
            return await response;
        }
        else{
            
            
            return await response;
        }

    }

}
export default WPCalendarEvent;